/* eslint-disable */
import { useSwaggerlessContext } from 'Context/SwaggerlessContext';
import React, { Component, Fragment, useEffect, useState } from 'react';
import { advisorView } from 'Context/ViewContext';
import { withHousehold } from 'Context/HouseholdContext';
import PropTypes from 'prop-types';
import {
  IncomeDetails as IncomeDetailsKey,
  SecondaryIncomeDetails as SecondaryIncomeDetailsKey,
  IncomeTaxSummary as IncomeTaxSummaryKey,
} from 'Consts/Questionnaire';
import { QueryVal } from 'Helpers/Query';
import { section } from 'Consts/Queries';
import { Tooltip } from 'Components/UI/Tooltip';
import Section from '../Section';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import './IncomeDetails.css';
import BoolInput from '../Fields/BoolInput';
import CurrencyInput from '../Fields/CurrencyInput';
import NumberInput from '../Fields/NumberInput';
import TextInput from '../Fields/TextInput';
import RadioInput from '../Fields/RadioInput';
import SelectInput from '../Fields/SelectInput';
import FieldList from '../Fields/FieldList';
import YearInput from '../Fields/YearInput';
import IncomeDetailsNetMonthlyIncomePicker
  from "Components/Universal/Questionnaire/ResourceSections/IncomeDetails/IncomeDetailsNetMonthlyIncomePicker";
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

class AnnuitySection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
    };
    this.ref1 = React.createRef();
    this.ref2 = React.createRef();
    this.handleTitleChange = this.handleTitleChange.bind(this);
  }

  handleTitleChange(key, val) {
    this.setState({ title: val });
  }

  render() {
    const { title } = this.state;
    const {
      props: { id, children: removeButton, expanded },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.25}
        title={title || 'New annuity'}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <CurrencyInput
          name={`primaryAnnuityAnnualIncomeAmount.${id}`}
          answerKey="primaryAnnuityAnnualIncomeAmount"
          placeholder="Annual income amount"
        />
        <TextInput
          name={`primaryAnnuityCompany.${id}`}
          answerKey="primaryAnnuityCompany"
          placeholder="Company"
          onChange={this.handleTitleChange}
        />
        <RadioInput
          name={`primaryAnnuityBenefitElection.${id}`}
          answerKey="primaryAnnuityBenefitElection"
          laceholder="Benefit election"
          options={[
            { id: 'single-life', text: 'Single life' },
            {
              id: 'joint-and-survivor',
              text: 'Joint & survivor',
              showWhileSelected: this.ref1,
            },
            {
              id: 'period-certain',
              text: 'Period certain',
              showWhileSelected: this.ref2,
            },
          ]}
        />
        <NumberInput
          name={`primaryAnnuitySurvivorshipRate.${id}`}
          answerKey="primaryAnnuitySurvivorshipRate"
          placeholder="Survivorship rate"
          ref={this.ref1}
          suffix="%"
          decimalScale={2}
        />
        <NumberInput
          name={`primaryAnnuityNumberOfYears.${id}`}
          answerKey="primaryAnnuityNumberOfYears"
          placeholder="Number of years"
          ref={this.ref2}
          decimalScale={0}
        />
      </LabeledVerticalExpander>
    );
  }
}

AnnuitySection.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.any,
  expanded: PropTypes.bool,
};

AnnuitySection.defaultProps = {
  children: null,
  expanded: true,
};

class PensionSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
    };
    this.ref1 = React.createRef();
    this.ref2 = React.createRef();
    this.handleTitleChange = this.handleTitleChange.bind(this);
  }

  handleTitleChange(key, val) {
    this.setState({ title: val });
  }

  render() {
    const { title } = this.state;
    const {
      props: { id, children: removeButton, expanded },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.25}
        title={title || 'New pension'}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <CurrencyInput
          name={`primaryPensionAnnualIncomeAmount.${id}`}
          answerKey="primaryPensionAnnualIncomeAmount"
          placeholder="Annual income amount"
        />
        <TextInput
          name={`primaryPensionCompany.${id}`}
          answerKey="primaryPensionCompany"
          placeholder="Company"
          onChange={this.handleTitleChange}
        />
        <RadioInput
          name={`primaryPensionBenefitElection.${id}`}
          answerKey="primaryPensionBenefitElection"
          laceholder="Benefit election"
          options={[
            { id: 'single-life', text: 'Single life' },
            {
              id: 'joint-and-survivor',
              text: 'Joint & survivor',
              showWhileSelected: this.ref1,
            },
            {
              id: 'period-certain',
              text: 'Period certain',
              showWhileSelected: this.ref2,
            },
          ]}
        />
        <NumberInput
          name={`primaryPensionSurvivorshipRate.${id}`}
          answerKey="primaryPensionSurvivorshipRate"
          placeholder="Survivorship rate"
          ref={this.ref1}
          suffix="%"
          decimalScale={2}
        />
        <NumberInput
          name={`primaryPensionNumberOfYears.${id}`}
          answerKey="primaryPensionNumberOfYears"
          placeholder="Number of years"
          ref={this.ref2}
          decimalScale={0}
        />
      </LabeledVerticalExpander>
    );
  }
}

const IncomeDetailsSection = ({ clientResource, id }) => (
  <Section
    transitionSpeed={0.25}
    title="Income Details"
    sectionKey={IncomeDetailsKey}
    expanded={QueryVal(section) === IncomeDetailsKey}
  >
    <div id="income-details-section">
      <IncomeDetailsNetMonthlyIncomePicker clientResource={clientResource}/>
      <p className="bold">
        Enter your <strong>annual</strong> income details for the following:
      </p>
      Do you have earned income?
      <Fragment>
        <CurrencyInput
          name={`clientAnnualSalary.${id}`}
          answerKey="clientAnnualSalary"
          placeholder="Annual salary"
        />
        <NumberInput
          name={`clientNumPayPeriodsPerYear.${id}`}
          answerKey="clientNumPayPeriodsPerYear"
          placeholder="Number of pay periods per year"
          decimalScale={0}
          min={0}
          test="clientNumPayPeriodsPerYear"
        />
        <CurrencyInput
          name={`clientBonusAndCommission.${id}`}
          answerKey="clientBonusAndCommission"
          placeholder="Bonus/commission"
        />
        <Tooltip title="e.g. annual, quarterly, etc.">
          <NumberInput
            name={`clientFrequencyOfPayments.${id}`}
            answerKey="clientFrequencyOfPayments"
            placeholder="Frequency of payments"
          />
        </Tooltip>
        <CurrencyInput
          name={`clientSelfEmployedEarnings.${id}`}
          answerKey="clientSelfEmployedEarnings"
          placeholder="Self-employed earnings"
        />
      </Fragment>
      <br />
      Do you have other income sources?
      <Fragment>
        <CurrencyInput
          name={`clientAnnualDividendAndInvestmentIncome.${id}`}
          answerKey="clientAnnualDividendAndInvestmentIncome"
          placeholder="Annual dividend and investment income"
        />
        <CurrencyInput
          name={`clientAnnualTrustIncome.${id}`}
          answerKey="clientAnnualTrustIncome"
          placeholder="Annual trust income"
        />
        <CurrencyInput
          name={`clientAnnualRentalIncome.${id}`}
          answerKey="clientAnnualRentalIncome"
          placeholder="Annual rental income"
        />
        <CurrencyInput
          requiredView={advisorView}
          name={`clientAnnualOtherIncome.${id}`}
          answerKey="clientAnnualOtherIncome"
          placeholder="Annual other income"
        />
        <br />
        Do you have social security income?
        <Fragment>
          <SelectInput
            label="Type of social security benefit"
            name={`clientSocialSecurityBenefitType.${id}`}
            answerKey="clientSocialSecurityBenefitType"
            options={[
              { id: '', value: '- Please select -' },
              { id: 'personal', value: 'Personal/Own' },
              { id: 'survivor', value: 'Survivor/Widow(er)' },
              { id: 'disability', value: 'Disability' },
              { id: 'child', value: "Children's" },
            ]}
          />
          <CurrencyInput
            name={`clientAnnualSocialSecurityIncome.${id}`}
            answerKey="clientAnnualSocialSecurityIncome"
            placeholder="Annual income amount"
          />
        </Fragment>
        <br />
        <FieldList
          label="Annuities"
          addLabel="Add an annuity"
          keyPrefix="primaryAnnuity"
          Of={AnnuitySection}
        />
        <FieldList
          label="Pension income"
          addLabel="Add a pension income"
          keyPrefix="primaryPensions"
          Of={PensionSection}
        />
      </Fragment>
    </div>
  </Section>
);

const SecondaryIncomeDetailsSection = props => {
  const {
    id,
    clientResource,
  } = props;

  const { householdResource } = useSimpleHousehold();
  const { getQuestionnaireAnswer } = useSwaggerlessContext();

  const [maritalStatus, setMaritalStatus] = useState(null);

  useEffect(() => {
    if (!householdResource) {
      return;
    }
    getQuestionnaireAnswer(householdResource.id(), 'clientMaritalStatus')
      .then((res) => setMaritalStatus(res.attributes.value));
  }, [householdResource]);

  if (maritalStatus === null) {
    return null;
  }

  // don't display this if the client isn't married
  if (maritalStatus !== 'married' && maritalStatus !== 'significantOther') {
    return null;
  }

  return (
    <Section
      transitionSpeed={0.25}
      title="Significant Other Income Details"
      sectionKey={SecondaryIncomeDetailsKey}
      expanded={QueryVal(section) === SecondaryIncomeDetailsKey}
    >
      <div id="income-details-section">
        <IncomeDetailsNetMonthlyIncomePicker clientResource={clientResource}/>
        <p className="bold">
          Enter your annual income details for the following:
        </p>
        Does your significant other have earned income?
        <Fragment>
          <CurrencyInput
            name={`clientSecondaryAnnualSalary.${id}`}
            answerKey="clientSecondaryAnnualSalary"
            placeholder="Annual salary"
          />
          <NumberInput
            name={`clientSecondaryNumPayPeriodsPerYear.${id}`}
            answerKey="clientSecondaryNumPayPeriodsPerYear"
            placeholder="Number of pay periods per year"
            decimalScale={0}
            min={0}
            test="clientSecondaryNumPayPeriodsPerYear"
          />
          <CurrencyInput
            name={`clientSecondaryBonusAndCommission.${id}`}
            answerKey="clientSecondaryBonusAndCommission"
            placeholder="Bonus/commission"
          />
          <Tooltip title="e.g. annual, quarterly, etc.">
            <NumberInput
              name={`clientSecondaryFrequencyOfPayments.${id}`}
              answerKey="clientSecondaryFrequencyOfPayments"
              placeholder="Frequency of payments"
            />
          </Tooltip>
          <CurrencyInput
            name={`clientSecondarySelfEmployedEarnings.${id}`}
            answerKey="clientSecondarySelfEmployedEarnings"
            placeholder="Self-employed earnings"
          />
        </Fragment>
        <br />
        Does your significant other have other income sources?
        <Fragment>
          <CurrencyInput
            name={`clientSecondaryAnnualDividendAndInvestmentIncome.${id}`}
            answerKey="clientSecondaryAnnualDividendAndInvestmentIncome"
            placeholder="Annual dividend and investment income"
          />
          <CurrencyInput
            name={`clientSecondaryAnnualTrustIncome.${id}`}
            answerKey="clientSecondaryAnnualTrustIncome"
            placeholder="Annual trust income"
          />
          <CurrencyInput
            name={`clientSecondaryAnnualRentalIncome.${id}`}
            answerKey="clientSecondaryAnnualRentalIncome"
            placeholder="Annual rental income"
          />
          <CurrencyInput
            requiredView={advisorView}
            name={`clientSecondaryAnnualOtherIncome.${id}`}
            answerKey="clientSecondaryAnnualOtherIncome"
            placeholder="Annual other income"
          />
          <br />
          Does your significant other have social security income?
          <Fragment>
            <SelectInput
              label="Type of social security benefit"
              name={`clientSecondarySocialSecurityBenefitType.${id}`}
              answerKey="clientSecondarySocialSecurityBenefitType"
              options={[
                { id: '', value: '- Please select -' },
                { id: 'personal', value: 'Personal/Own' },
                { id: 'survivor', value: 'Survivor/Widow(er)' },
                { id: 'disability', value: 'Disability' },
                { id: 'child', value: "Children's" },
              ]}
            />
            <CurrencyInput
              name={`clientSecondaryAnnualSocialSecurityIncome.${id}`}
              answerKey="clientSecondaryAnnualSocialSecurityIncome"
              placeholder="Annual income amount"
            />
          </Fragment>
          <br />
          <Fragment>
            <FieldList
              label="Annuities"
              addLabel="Add an annuity"
              keyPrefix="secondaryAnnuity"
              Of={AnnuitySection}
            />
          </Fragment>
          <Fragment>
            <FieldList
              label="Primary Pension Income"
              addLabel="Add a pension income"
              keyPrefix="secondaryPensions"
              Of={PensionSection}
            />
          </Fragment>
        </Fragment>
      </div>
    </Section>
  );
};

const IncomeTaxSummarySection = ({ id }) => (
  <Section
    transitionSpeed={0.25}
    title="Income Tax Summary"
    sectionKey={IncomeTaxSummaryKey}
    expanded={QueryVal(section) === IncomeTaxSummaryKey}
  >
    <div id="income-details-section">
      <p className="bold">
        For the following, enter information about your most recently filed
        income tax return.
      </p>
      <Tooltip title="e.g. 2017">
        <YearInput
          requiredView={advisorView}
          name={`clientMostRecentIncomeTaxReturnOnFileYear.${id}`}
          answerKey="clientMostRecentIncomeTaxReturnOnFileYear"
          placeholder="Most recent income tax return on file"
        />
      </Tooltip>
      <CurrencyInput
        requiredView={advisorView}
        name={`clientRealizedCapitalGains.${id}`}
        answerKey="clientRealizedCapitalGains"
        placeholder="Realized capital gains"
      />
      <CurrencyInput
        requiredView={advisorView}
        name={`clientAdjustedGrossIncome.${id}`}
        answerKey="clientAdjustedGrossIncome"
        placeholder="Adjusted gross income"
      />
      Do you have itemized deductions?
      <br />
      <CurrencyInput
        requiredView={advisorView}
        name={`clientItemizedDeductions.${id}`}
        answerKey="clientItemizedDeductions"
        placeholder="Itemized deduction amount"
      />
      <CurrencyInput
        requiredView={advisorView}
        name={`clientTaxableIncome.${id}`}
        answerKey="clientTaxableIncome"
        placeholder="Taxable income"
      />
      <CurrencyInput
        requiredView={advisorView}
        name={`clientTotalFederalTaxPaid.${id}`}
        answerKey="clientTotalFederalTaxPaid"
        placeholder="Total tax paid (federal)"
      />
      Do you make estimated quarterly payments?
      <br />
      <CurrencyInput
        name={`clientEstimatedQuarterlyPayments.${id}`}
        answerKey="clientEstimatedQuarterlyPayments"
        placeholder="Estimated quarterly payments"
      />
      <CurrencyInput
        name={`clientCarryOverLosses.${id}`}
        answerKey="clientCarryOverLosses"
        placeholder="Carry over losses"
      />
      <CurrencyInput
        name={`clientRefundOrShortfall.${id}`}
        answerKey="clientRefundOrShortfall"
        placeholder="Refund/shortfalls"
        min={-999999999}
      />
      <BoolInput
        label="Alternative minimum tax?"
        name={`clientHasAlternativeMinimumTax.${id}`}
        answerKey="clientHasAlternativeMinimumTax"
      />
      <CurrencyInput
        name={`clientScheduleC.${id}`}
        answerKey="clientScheduleC"
        placeholder="Schedule C"
      />
      <CurrencyInput
        name={`clientScheduleE.${id}`}
        answerKey="clientScheduleE"
        placeholder="Schedule E"
      />
      <NumberInput
        name={`clientMarginalTaxBracket.${id}`}
        answerKey="clientMarginalTaxBracket"
        placeholder="Marginal tax bracket"
        suffix="%"
        decimalScale={2}
        min={0}
        max={100}
      />
      <NumberInput
        name={`clientLongTermCapitalGainsTaxBracket.${id}`}
        answerKey="clientLongTermCapitalGainsTaxBracket"
        placeholder="Long term capital gains bracket"
        suffix="%"
        decimalScale={2}
        min={0}
        max={100}
      />
      <NumberInput
        name={`clientEffectiveTaxRate.${id}`}
        answerKey="clientEffectiveTaxRate"
        placeholder="Effective tax rate"
        suffix="%"
        decimalScale={2}
        min={0}
        max={100}
      />
    </div>
  </Section>
);

const ConnectedSecondaryIncomeDetailsSection = withHousehold(SecondaryIncomeDetailsSection);

export {
  IncomeDetailsSection,
  ConnectedSecondaryIncomeDetailsSection as SecondaryIncomeDetailsSection,
  IncomeTaxSummarySection,
};
